import { chargeSquareCard, SaveSquareCard } from "api/square/square";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  CreditCard,
  PaymentForm,
  ApplePay,
  GooglePay,
} from "react-square-web-payments-sdk";
import ButtonPrimary from "shared/Button/ButtonPrimary";

type TokenResult = {
  status: string;
  token?: string;
  errors?: Array<{ message: string }>;
};

type VerifyBuyerResponseDetails = any; 

interface SquarePaymentFormProps {
  squareDetails: any; 
  onPaymentSuccess: (data: any) => void;
  onPaymentError: (error: string) => void;
  amount: number;
  bookingId: string; 
  renterId: string; 
  rentalAgreementChecked: boolean;
  privacyPolicyCheckedChecked: boolean;
}

const SquarePaymentForm: React.FC<SquarePaymentFormProps> = ({
  squareDetails,
  onPaymentSuccess,
  onPaymentError,
  amount,
  bookingId,
  renterId,
  rentalAgreementChecked = false,
  privacyPolicyCheckedChecked = false,
}) => {
  const [loading, setLoading] = useState(false);
  let loadingCheck = false;
  const handlePaymentFormSubmit = async (tokenResult: TokenResult) => {
    if (loadingCheck) return; 
    loadingCheck = true;
    if (!tokenResult.token) {
      onPaymentError("Payment token is missing.");
      return;
    }
    try {
      setLoading(true);
      const renterIdStr = String(renterId);
      let saveCardResponse = await SaveSquareCard(
        renterIdStr,
        tokenResult.token
      );

      const response = await chargeSquareCard(
        bookingId,
        saveCardResponse?.card?.id || ""
      );

      if (!response.error) {
        onPaymentSuccess(response);
      } else {
        onPaymentError(response.error);
      }
    } catch (error: unknown) {
      onPaymentError(error instanceof Error ? error.message : String(error));
    } finally {
      loadingCheck = false;
      setLoading(false);
    }
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = "#rswp-card-button { display: none !important; }";
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handleCustomPayClick = () => {
    if (rentalAgreementChecked !== true) {
      toast.error("Please agree to the Rental Agreement");
      return;
    }
    if (privacyPolicyCheckedChecked !== true) {
      toast.error("Please agree to Privacy & Cancellation Policies");
      return;
    }
    const squareBtn = document.getElementById("rswp-card-button");
    if (squareBtn) {
      squareBtn.click();
    }
  };

  return (
    <div className="mt-8 pt-8">
      <span className="text-lg text-text-color font-semibold mt-4">
        Payment Information
      </span>
      <div className="mb-6"></div>
      <PaymentForm
        applicationId={squareDetails?.application_id} 
        locationId={squareDetails?.location_id}
        cardTokenizeResponseReceived={handlePaymentFormSubmit}
        createPaymentRequest={() => ({
          countryCode: "US",
          currencyCode: "USD",
          total: {
            amount: amount.toString(),
            label: "Total",
          },
        })}
      >
        <CreditCard />
      </PaymentForm>
      <ButtonPrimary
        type="button"
        className="w-full mt-4 rounded-md"
        onClick={handleCustomPayClick}
        disabled={loading}
      >
        {loading ? (
          <div className="flex justify-center items-center col-span-full">
            <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-secondary-100"></div>
          </div>
        ) : (
          "Pay & Book"
        )}
      </ButtonPrimary>
    </div>
  );
};

export default SquarePaymentForm;
